import { FC } from "react";
import { Select } from "..";
import {
    TIMESLOT_FILTER_OPTIONS,
    TimeslotCategory,
} from "../../../utils/timeslots";

type Props = {
    value: TimeslotCategory | undefined;
    onChanged: (value: TimeslotCategory | undefined) => void;
};

/** Filtre admin : Matin (8h–12h) / Après-midi / Soir — pas les créneaux unitaires. */
const TimeslotsSelect: FC<Props> = ({ value, onChanged }) => {
    return (
        <Select
            value={value ?? ""}
            onChanged={(v) =>
                onChanged(
                    v
                        ? (v as TimeslotCategory)
                        : undefined
                )
            }
        >
            <option value="">-</option>
            {TIMESLOT_FILTER_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                    {opt.label}
                </option>
            ))}
        </Select>
    );
};

export default TimeslotsSelect;
